import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("g", null, [
            _createElementVNode("path", {
              fill: "#FF5537",
              d: "M13.908 4.647l-2.413 4.888c-.049.099-.142.167-.251.183l-5.395.784c-.508.073-.977.313-1.335.68-.9.923-.881 2.4.042 3.3l3.904 3.805c.078.076.114.187.096.295l-.922 5.373c-.087.506-.004 1.026.234 1.48.6 1.141 2.01 1.58 3.152.98l4.825-2.537c.097-.051.213-.051.31 0l4.825 2.537c.455.239.975.321 1.48.234 1.27-.218 2.124-1.424 1.906-2.694l-.922-5.373c-.018-.108.018-.219.096-.295l3.904-3.805c.368-.359.607-.828.68-1.336.186-1.275-.698-2.459-1.973-2.644l-5.395-.784c-.109-.016-.202-.084-.25-.183l-2.414-4.888c-.227-.46-.6-.833-1.06-1.06-1.155-.57-2.554-.096-3.124 1.06zm2.24.733c.065.033.118.086.15.152l2.414 4.889c.34.688.996 1.166 1.756 1.276l5.395.784c.183.026.309.196.282.378-.01.072-.044.14-.097.19l-3.904 3.806c-.55.536-.8 1.308-.67 2.065l.92 5.373c.032.182-.09.354-.271.385-.073.012-.147 0-.212-.033l-4.825-2.537c-.68-.358-1.492-.358-2.172 0l-4.825 2.537c-.163.085-.365.023-.45-.14-.034-.065-.046-.14-.034-.212l.922-5.373c.13-.757-.121-1.53-.671-2.065l-3.904-3.806c-.132-.128-.135-.34-.006-.47.051-.053.118-.088.19-.098l5.396-.784c.76-.11 1.417-.588 1.756-1.276l2.413-4.89c.068-.137.218-.207.362-.179l.085.028z",
              transform: "translate(-1152 -844) translate(992 844) translate(160)"
            })
          ])
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }